import { connect } from "react-redux";
import { useNavigate } from "react-router-dom"
import { URL } from "../../../routers/constants";
import { disconnectPage } from "../../../store/action/pageAction";

const ActionPage = (props) => {
   const { disconnectPage } = props;
   const navigate = useNavigate();
   const redirectAddPage = () => {
      navigate(URL.CHANNEL);
   }

   return (
      <div className="app-messaging-first--actions">
         <div className="app-messaging-first--disconnect">
            <div className="app-messaging-first--menu-item app-messaging-first--disconnect--container">
               <div className="app-messaging-first--disconnect--icon">
                  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
                     <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M6.7 3.1l1.245-1.245a3.007 3.007 0 014.2 0v0a3.007 3.007 0 010 4.2L10.9 7.3M7.3 10.9l-1.245 1.245a3.007 3.007 0 01-4.2 0v0a3.007 3.007 0 010-4.2L3.1 6.7M4.6 9.4l.6-.6M8.8 5.2l.6-.6M1 1l12 12">
                     </path>
                  </svg>
               </div>
               <div className="app-messaging-first--disconnect--desc" onClick={disconnectPage}>
                  Ngắt kết nối trang hiện tại
               </div>
            </div>
         </div>
         <div className="app-messaging-first--add-new-page" onClick={redirectAddPage}>
            <div className="app-messaging-first--menu-item app-messaging-first--add-new-page--container">
               <div className="app-messaging-first--add-new-page--icon">
                  <svg width="14" height="14" fill="none" viewBox="0 0 14 14">
                     <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M7 4.273v5.454M9.727 7H4.273">
                     </path>
                     <path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M7 13A6 6 0 107 1a6 6 0 000 12z" clipRule="evenodd">
                     </path>
                  </svg>
               </div>
               <div className="app-messaging-first--add-new-page--title">
                  Thêm trang mới
               </div>
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = () => {
   return {};
};

export default connect(mapStateToProps, {
   disconnectPage
})(ActionPage)